import { Component, OnInit } from '@angular/core';
import { RouterLink } from '@angular/router';
import { NgIconComponent, provideIcons } from '@ng-icons/core';
import { heroArrowLeft } from '@ng-icons/heroicons/outline';
import { OauthService, UserInfo } from '../../services/oauth.service';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-dashboard',
  imports: [RouterLink, NgIconComponent],
  templateUrl: './dashboard.component.html',
  styleUrl: './dashboard.component.css',
  providers: [provideIcons({ heroArrowLeft })],
})
export class DashboardComponent implements OnInit {
  userInfo: UserInfo | null = null;
  percentageUsed: number | null = null;

  constructor(private auth: OauthService, private http: HttpClient) { }

  ngOnInit() {
    this.auth.getUser().then((user) => {
      if (user) {
        this.userInfo = user;
        this.getUserQuotaUsage();
      }
    });
  }

  getUserQuotaUsage() {
    this.http.get(`${environment.backendUrl}/api/chat/usage`).subscribe({
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      next: (response: any) => {
        if (response && response.data && response.data.usage !== undefined && response.data.limit !== undefined) {
          this.percentageUsed = 100 * response.data.usage / response.data.limit;
          this.percentageUsed = Math.round(100 - this.percentageUsed);
        } else {
          this.percentageUsed = null; // Default value
        }
      },
      error: (error) => {
        console.error('Error fetching user quota usage:', error);
        this.percentageUsed = null; // Default value on error
      }
    });
  }

}
